import { render, staticRenderFns } from "./UserGroupSelection.vue?vue&type=template&id=1dcd43d9&scoped=true"
import script from "./UserGroupSelection.vue?vue&type=script&lang=js"
export * from "./UserGroupSelection.vue?vue&type=script&lang=js"
import style0 from "./UserGroupSelection.vue?vue&type=style&index=0&id=1dcd43d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcd43d9",
  null
  
)

export default component.exports